export default {
    projectName: 'zkparty',
    allowReset: false,
}